import * as React from 'react';
import styled from 'styled-components';
import { cssClampValue, arraySample } from '../../utils/common';
import illustration0 from './images/illustration0.svg';
import illustration1 from './images/illustration1.svg';
import illustration2 from './images/illustration2.svg';
import illustration3 from './images/illustration3.svg';
import illustration4 from './images/illustration4.svg';
import illustration5 from './images/illustration5.svg';

const Image = styled.img`
  object-fit: cover;
  aspect-ratio: 1/1;
  border-radius: ${cssClampValue(20, 30)};
`;

interface Props extends React.ComponentPropsWithoutRef<'img'> {}

const defaultProfilePhotos = [
  illustration0,
  illustration1,
  illustration2,
  illustration3,
  illustration4,
  illustration5,
];

export default function MemberProfilePhoto({ src, ...rest }: Props) {
  const [randomImage, setRandomImage] = React.useState<string>(defaultProfilePhotos[0]);

  React.useEffect(() => {
    setRandomImage(arraySample(defaultProfilePhotos));
  }, []);

  let imageSrc = src || randomImage;

  // change in size applies to profile photo URLs generated by Google Auth
  if (imageSrc.includes('=s96-c')) {
    imageSrc = imageSrc.replace('=s96-c', '=s800-c');
  }

  // change in size applies to author's profile photo URLs generated by Gravater in WordPress
  if (imageSrc.includes('s=96&')) {
    imageSrc = imageSrc.replace('s=96&', 's=220&');
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Image src={imageSrc} {...rest} referrerPolicy="no-referrer" />;
}
